<div class="details" [class.disabled]="isSoldOut">
  <img class="icon" [src]="stakeable.id | assetIcon" alt="{{ 'logo_alt_text' | translate }}" />
  <div class="details-group">
    <span class="name">{{ stakeable.name }}</span>
    <span class="symbol">{{ stakeable.symbol }}</span>
  </div>
</div>

<div class="balance" [class.disabled]="isSoldOut">
  <span class="balance-amount">
    {{ defaultWalletBalance | fiat_precision_symbol: { id: fiat?.getId(), currencies: [fiat], symbol: true } }}
  </span>
</div>

<div class="reward">
  @if (isSoldOut) {
    <span class="sold-out">{{ "sold_out" | translate }}</span>
  } @else {
    <span class="percentage">{{ stakeable.yearlyInterest | number: "1.2" | percent_symbol }}</span>
    <span class="interval">{{ "per_year" | translate }}</span>
  }

</div>
